module.exports = "<div class=\"mt-3 h7\">\n    QUESTIONS? Restaurant care is available at\n    <div class=\"customer_care\">\n      {{ctrl.restaurantCareNumber}}\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/home/receipt/sections/restaurantCare.html
// module id = 751
// module chunks = 0